module.exports = __webpack_public_path__ + "img/acacia_certified_new.9bc973a2.png";